var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99973 1.66669C11.7697 1.66669 13.1389 3.21835 12.9197 4.97419L12.8097 5.85252C12.6322 7.27002 11.4281 8.33335 9.99973 8.33335C8.57139 8.33335 7.36639 7.27002 7.18973 5.85252L7.07973 4.97419C6.86056 3.21752 8.22973 1.66669 9.99973 1.66669Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08615 11.425C8.36198 10.6367 11.6387 10.6367 14.9145 11.425C15.487 11.5625 15.9328 12.0142 16.0945 12.5808L16.9995 15.75C17.2728 16.7067 16.652 17.6925 15.6712 17.8575C11.8903 18.4925 8.10948 18.4925 4.32865 17.8575C3.34698 17.6925 2.72698 16.7067 3.00032 15.75L3.90532 12.5808C4.06698 12.0142 4.51365 11.5633 5.08615 11.425Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutline);
export default __webpack_public_path__ + "static/media/profile-outline.9a149462269caaeaa13e8af9f8090d77.svg";
export { ForwardRef as ReactComponent };